<template>
  <v-form lazy-validation>
    <v-row no-gutters>
      <div class="col-12 col-md-6">
        <Input
          class="mx-4"
          :data="{
            text: this.text.firstname,
            name: 'firstname',
            onkeyup: true,
            onblur: true,
            rules: this.firstnameRules,
            value: this.user.info.firstname
          }"
          v-on:childToParent="inputFormNameFirst"
        />
      </div>

      <div class="col-12 col-md-6">
        <Input
          class="mx-4"
          :data="{
            text: this.text.lastname,
            name: 'lastname',
            onkeyup: true,
            onblur: true,
            rules: this.lastnameRules,
            value: this.user.info.lastname
          }"
          v-on:childToParent="inputFormNameLast"
        />
      </div>
    </v-row>

    <v-row no-gutters>
      <div class="col-12">
        <Input
          class="mx-4"
          :data="{
            text: this.text.address,
            name: 'address',
            onkeyup: true,
            onblur: true,
            rules: this.addressRules,
            value: this.user.info.address
          }"
          v-on:childToParent="inputFormAddress"
        />
      </div>
    </v-row>
    <ZipcodeCityLookup
      :user="this.user"
      :zipcode="this.user.info.zipcode"
      :city="this.user.info.city"
      :cityInputIsDisabled="false"
      :rules="valRules"
      @zipcodeChanged="inputFormZipcode"
      @cityChanged="inputFormCity"
    />
    <v-row no-gutters>
      <div class="col-12 col-md-6">
        <Input
          class="mx-4"
          :data="{
            text: this.text.email,
            name: 'email',
            onkeyup: true,
            onblur: true,
            rules: this.emailRules,
            value: this.user.info.email
          }"
          v-on:childToParent="inputFormEmail"
        />
      </div>
      <div class="col-12 col-md-6">
        <Input
          class="mx-4"
          :data="{
            id: 1,
            text: this.text.phone,
            name: 'phone',
            onkeyup: true,
            onblur: true,
            rules: this.phoneRules,
            value: this.user.info.phone
          }"
          v-on:childToParent="inputFormNumberPhone"
        />
      </div>
    </v-row>
    <v-row no-gutters>
      <div class="col-12 mt-4">
        <Checkbox
          class="mx-4"
          :item="{
            text: this.text.checkbox,
            rules: this.acceptedRules,
            checked: this.user.info.accepted
          }"
          v-on:childToParent="inputFormAccepted"
        />
      </div>
    </v-row>
    <v-row no-gutters v-if="user.specialProperties.forwarding.endpoint != ''">
      <div class="col-12 mb-5">
        <Checkbox
          class="mx-4"
          :item="{
            text: this.text.marketingConsent,
            checked: user.specialProperties.forwarding.marketingConsent
          }"
          v-on:childToParent="marketingConsentAccepted"
        />
      </div>
    </v-row>
  </v-form>
</template>

<script>
import localizationTexts from '@/localization/texts.json';
import Input from '@/components/fragments/input.vue';
import Checkbox from '@/components/fragments/checkbox.vue';
import ZipcodeCityLookup from '@/components/ZipcodeCityLookup.vue';
import Vue from 'vue';
import { createNamespacedHelpers } from 'vuex';
const { mapGetters } = createNamespacedHelpers('user');

export default Vue.extend({
  name: 'FormCustomer',
  data() {
    return {
      valRules: '',
      firstname: '',
      lastname: '',
      adress: '',
      address2: '',
      state: '',
      region: '',
      country: '',
      email: '',
      phone: '',
      accepted: false,
      text: {
        firstname: '',
        lastname: '',
        address: '',
        zipcode: '',
        city: '',
        email: '',
        phone: '',
        checkbox: ''
      },
      firstnameRules: [
        (v) => !!v || localizationTexts[this.user.config.language].validation.missing.firstname,
        (v) => v.trim().length <= 50 || localizationTexts[this.user.config.language].validation.specific.firstnameLength,
        (v) => v.trim().length > 1 || localizationTexts[this.user.config.language].validation.specific.space
      ],
      lastnameRules: [
        (v) => !!v || localizationTexts[this.user.config.language].validation.missing.lastname,
        (v) => v.length <= 50 || localizationTexts[this.user.config.language].validation.specific.lastnameLength,
        (v) => v.trim().length > 1 || localizationTexts[this.user.config.language].validation.specific.space
      ],
      addressRules: [
        (v) => !!v || localizationTexts[this.user.config.language].validation.missing.address,
        (v) => v.length <= 35 || localizationTexts[this.user.config.language].validation.specific.addressMaxLength,
        (v) => v.trim().length > 1 || localizationTexts[this.user.config.language].validation.specific.space
      ],
      emailRules: [
        (v) => !!v || localizationTexts[this.user.config.language].validation.missing.email,
        (v) =>
          RegExp(this.$store.getters['user/user'].config.prop.email).test(v) ||
          localizationTexts[this.user.config.language].validation.specific.emailValid
      ],
      phoneRules: [
        (v) => !!v || localizationTexts[this.user.config.language].validation.missing.phoneNumber,
        (v) =>
          RegExp(this.$store.getters['user/user'].config.prop.phone).test(v) ||
          localizationTexts[this.user.config.language].validation.specific.phoneValid
      ],
      acceptedRules: [(v) => !!v || localizationTexts[this.user.config.language].validation.missing.accepted]
    };
  },
  mounted() {
    this.text.firstname = localizationTexts[this.user.config.language].pageContact.firstname;
    this.text.lastname = localizationTexts[this.user.config.language].pageContact.lastname;
    this.text.address = localizationTexts[this.user.config.language].pageContact.address;
    this.text.email = localizationTexts[this.user.config.language].pageContact.email;
    this.text.phone = localizationTexts[this.user.config.language].pageContact.telephoneNumber;
    this.text.checkbox = localizationTexts[this.user.config.language].pageContact.checkbox;
    this.text.marketingConsent =
      this.user.specialProperties.forwarding.marketingConsentText != ''
        ? this.user.specialProperties.forwarding.marketingConsentText
        : localizationTexts[this.user.config.language].pageContact.marketingConsent;
    this.valRules = this.$store.getters['user/user'].config.prop.zip;
  },
  components: {
    Input,
    Checkbox,
    ZipcodeCityLookup
  },
  methods: {
    inputFormNameFirst(payload) {
      this.firstname = payload;
      this.$store.dispatch('user/initStep', 3);
      this.$store.dispatch('user/initLoading', true);
      this.$store.dispatch('user/initUserNameFirst', payload).then(() => {
        this.$store.dispatch('user/initLoading', false);
      });
    },
    inputFormNameLast(payload) {
      this.lastname = payload;
      this.$store.dispatch('user/initLoading', true);
      this.$store.dispatch('user/initUserNameLast', payload).then(() => {
        this.$store.dispatch('user/initLoading', false);
      });
    },
    inputFormAddress(payload) {
      this.lastname = payload;
      this.$store.dispatch('user/initLoading', true);
      this.$store.dispatch('user/initUserAddress', payload).then(() => {
        this.$store.dispatch('user/initLoading', false);
      });
    },
    inputFormZipcode(payload) {
      this.$store.dispatch('user/initLoading', true);
      this.$store.dispatch('user/initUserZipcode', payload).then(() => {
        this.$store.dispatch('user/initLoading', false);
      });
    },
    inputFormCity(payload) {
      this.$store.dispatch('user/initLoading', true);
      this.$store.dispatch('user/initUserCity', payload).then(() => {
        this.$store.dispatch('user/initLoading', false);
      });
    },
    inputFormEmail(payload) {
      this.lastname = payload;
      this.$store.dispatch('user/initLoading', true);
      this.$store.dispatch('user/initUserEmail', payload).then(() => {
        this.$store.dispatch('user/initLoading', false);
      });
    },
    inputFormNumberPhone(payload) {
      this.lastname = payload;
      this.$store.dispatch('user/initLoading', true);
      this.$store.dispatch('user/initUserNumberPhone', payload).then(() => {
        this.$store.dispatch('user/initLoading', false);
      });
    },
    inputFormAccepted(payload) {
      this.accepted = payload;
      this.$store.dispatch('user/initLoading', true);
      this.$store.dispatch('user/initUserAccepted', payload).then(() => {
        this.$store.dispatch('user/initLoading', false);
      });
    },
    marketingConsentAccepted(payload) {
      this.$store.dispatch('user/initLoading', true);
      this.$store.dispatch('user/initMarketingConsent', payload).then(() => {
        this.$store.dispatch('user/initLoading', false);
      });
    }
  },
  computed: mapGetters(['user'])
});
</script>

<style scoped lang="scss"></style>

<i18n src="../localization/texts.json"></i18n>
